/* eslint-disable max-lines */
import { grid } from '@chakra-ui/react';
import { StyleSheet } from '@react-pdf/renderer';

export const styleSheet = StyleSheet.create({
	page: {
		flexDirection: 'column',
		backgroundColor: '#FFF',
		padding: 10,
		fontFamily: 'Inter',
		fontWeight: 400,
		fontSize: 10
	},
	header: {
		margin: 10,
		padding: 10
	},
	body: {
		margin: 10,
		padding: 10,
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column'
	},

	headerThreeColumns: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%'
	},
	headerLeftColumn: {
		width: '30%',
		flexDirection: 'column',
		paddingLeft: 30
	},
	headerCenterColumn: {
		width: '40%',
		flexDirection: 'column'
	},
	headerRightColumn: {
		width: '30%',
		flexDirection: 'column',
		paddingRight: 30
	},
	headerTitle: {
		fontSize: 20,
		marginBottom: 20,
		textAlign: 'center',
		color: 'black',
		fontWeight: 700,
		fontFamily: 'Inter',
		textTransform: 'uppercase'
	},
	flex: {
		flexDirection: 'row',
		gap: 10
	},
	marginBottom: {
		marginBottom: 5
	},
	marginTop: {
		marginTop: 10
	},
	heading: {
		fontWeight: 700,
		fontFamily: 'Inter',
		fontSize: 10
	},
	headingLarge: {
		width: '2in',
		flexDirection: 'row',
		fontWeight: 700,
		fontFamily: 'Inter',
		fontSize: 14,
		textAlign: 'left',
		borderBottomWidth: 1,
		borderBottomColor: '#000'
	},
	text: {
		fontSize: 10,
		fontWeight: 400,
		fontFamily: 'Inter'
	},
	tableHeaderRow: {
		flexDirection: 'row',
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid',
		backgroundColor: '#f2f2f2',
		fontFamily: 'Inter',
		fontWeight: 700,
		fontSize: 12,
		textAlign: 'center',
		alignContent: 'center',
		minHeight: 35,
		paddingVertical: 5
	},
	tableRow: {
		flexDirection: 'row',
		fontFamily: 'Inter',
		fontWeight: 400,
		textAlign: 'right',
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid'

	},
	tableCellBorderedLeft: {
		borderLeftWidth: 1,
		borderLeftColor: '#000',
		borderStyle: 'solid'
	},
	tableCellBorderedRight: {
		borderRightWidth: 1,
		borderRightColor: '#000',
		borderStyle: 'solid'
	},
	tableCellFirst: {
		fontSize: 10,
		width: '1.5in',
		textAlign: 'left',
		padding: '5px 5px 5px 5px'
	},
	tableCellSku: {
		fontSize: 10,
		width: '1.5in',
		textAlign: 'right',
		padding: '5px 5px 5px 5px'
	},
	tableCellDescription: {
		fontSize: 10,
		width: '2in',
		textAlign: 'right',
		padding: '5px 5px 5px 5px'
	},
	tableCellPrice: {
		fontSize: 10,
		width: '1.5in',
		textAlign: 'right',
		padding: '5px 5px 5px 5px'
	},
	tableColumnQty: {
		fontSize: 10,
		width: '1.25in',
		textAlign: 'right',
		padding: '5px 5px 5px 5px'
	},
	tableCellSubtotal: {
		fontSize: 10,
		width: '1in',
		padding: '0 5px 0 5px'
	},
	safeText: {
		fontSize: 10,
		fontFamily: 'Helvetica',
		fontWeight: 'normal'
	},
	safeDiscountNotice: {
		fontSize: 8,
		fontStyle: 'italic',
		color: '#555',
		fontFamily: 'Helvetica',
		fontWeight: 'normal'
	},
	summaryCellFirst: {
		fontSize: 10,
		width: '50%',
		textAlign: 'left',
		padding: '5px 5px 5px 5px'
	},
	tableColumnTotal: {
		fontSize: 10,
		width: '50%',
		textAlign: 'right',
		padding: '5px 5px 5px 5px'
	},
	block: {
		marginBottom: 20
	},
	container: {
		marginVertical: 20
	},
	containerSmall: {
		marginVertical: 10
	},
	containerSmallLast: {
		marginTop: 5
	},
	containerXSmall: {
		marginBottom: 5
	},
	containerRight: {
		alignItems: 'flex-end',
		marginVertical: 1,
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid',
		height: '.5in',
		width: '2in',
		marginLeft: 'auto'
	},
	header3Column: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	headerSingleColumn: {
		width: '20%'
	},
	colorInfo: {
		color: '#8394A4',
		fontSize: 10
	},
	pullRight: {
		textAlign: 'right'
	},
	pullLeft: {
		textAlign: 'left'
	},
	fontWeightBold: {
		fontWeight: 700
	},
	pageHeaderImage: {
		width: 140,
		height: 'auto'
	},
	proposalPage: {
		flexDirection: 'column',
		backgroundColor: '#FFF',
		paddingTop: 0,
		paddingBottom: 10,
		paddingHorizontal: 15,
		fontFamily: 'Inter',
		fontWeight: 400,
		fontSize: 10,
		justifyContent: 'space-between'
	},
	containerCenter: {
		marginHorizontal: 'auto',
		marginVertical: 0,
		paddingVertical: 0
	},
	pageIntroHeadingRed: {
		color: '#FF3131',
		fontWeight: 700,
		textAlign: 'center'
	},
	pageIntroHeroImage: {
		width: 350,
		height: 'auto',
		marginVertical: 10,
		marginHorizontal: 'auto'
	},
	orangeBox: {
		backgroundColor: '#FF2400',
		borderRadius: 5,
		padding: 10,
		width: '60%',
		fontWeight: 700,
		color: '#FFF',
		textAlign: 'center'
	},
	fontWeightNormal: {
		fontWeight: 400
	},
	fontColorRed: {
		color: '#FF3131'
	},
	text2Col: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		display: 'flex',
		width: '75%',
		alignItems: 'flex-start'
	},
	text2ColItem: {
		width: '45%',
		textAlign: 'left'
	},
	spaceLeft: {
		marginLeft: 60
	},
	lineHeight: {
		lineHeight: 1.4
	},
	tableRevision: {
		width: '70%'
	},
	tableRevisionHeaderRow: {
		flexDirection: 'row',
		backgroundColor: '#A5A5A5',
		fontFamily: 'Inter',
		fontWeight: 700,
		fontSize: 12,
		textAlign: 'center',
		alignContent: 'center'
	},
	tableRevisionRow: {
		flexDirection: 'row',
		fontFamily: 'Inter',
		fontWeight: 400,
		textAlign: 'center',
		backgroundColor: '#eee'
	},
	tableRevisionCell: {
		fontSize: 10,
		width: '1.5in',
		padding: 5,
		textAlign: 'center'
	},
	tableRevisionCellDescription: {
		fontSize: 10,
		width: '4in',
		padding: 5,
		textAlign: 'center'
	},
	tableRevisionBorderRight: {
		borderRightWidth: 1,
		borderRightColor: '#fff',
		borderStyle: 'solid'
	},
	tableRevisionBorderLeft: {
		borderLeftWidth: 1,
		borderLeftColor: '#fff',
		borderStyle: 'solid'
	},
	tableRevisionBorderBottom: {
		borderBottomWidth: 1,
		borderBottomColor: '#fff',
		borderStyle: 'solid'
	},
	tableRevision2BorderBottom: {
		borderBottomWidth: 2,
		borderBottomColor: '#fff',
		borderStyle: 'solid'
	},
	tableRevisionRowAlt: {
		flexDirection: 'row',
		fontFamily: 'Inter',
		fontWeight: 400,
		textAlign: 'center',
		backgroundColor: '#d9d9d9'
	},
	tableCasting: {
		width: '30%'
	},
	tableCastingHeaderRow: {
		flexDirection: 'row',
		backgroundColor: '#A5A5A5',
		fontFamily: 'Inter',
		fontWeight: 700,
		fontSize: 10,
		textAlign: 'center',
		alignContent: 'center',
		color: '#fff'
	},
	tableCastingRow: {
		flexDirection: 'row',
		fontFamily: 'Inter',
		fontWeight: 400,
		textAlign: 'center',
		backgroundColor: '#eee'
	},
	tableCastingCell: {
		fontSize: 10,
		width: '1in',
		padding: 5,
		textAlign: 'center'
	},
	tableCastingBorderRight: {
		borderRightWidth: 1,
		borderRightColor: '#fff',
		borderStyle: 'solid'
	},
	tableCastingBorderLeft: {
		borderLeftWidth: 1,
		borderLeftColor: '#fff',
		borderStyle: 'solid'
	},
	tableCastingBorderBottom: {
		borderBottomWidth: 1,
		borderBottomColor: '#fff',
		borderStyle: 'solid'
	},
	tableCasting2BorderBottom: {
		borderBottomWidth: 2,
		borderBottomColor: '#fff',
		borderStyle: 'solid'
	},
	tableCastingRowAlt: {
		flexDirection: 'row',
		fontFamily: 'Inter',
		fontWeight: 400,
		textAlign: 'center',
		backgroundColor: '#d9d9d9'
	},
	fullImage: {
		width: 390,
		height: 'auto'
	},
	overheadImage: {
		width: 590,
		height: 'auto'
	},
	noteContainer: {
		backgroundColor: '#eee',
		fontSize: 10,
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid',
		lineHeight: 1.5,
		width: '70%',
		padding: 10
	},
	textUpperCase: {
		textTransform: 'uppercase'
	},
	pullCenter: {
		textAlign: 'center'
	},
	containerSection: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'stretch',
		gap: 10,
		marginTop: 10
	},
	pageName: {
		textTransform: 'uppercase',
		fontWeight: 700,
		marginTop: 10
	},
	logo: {
		width: 80,
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: 20,
		marginBottom: 5
	},
	containerPanel: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between'
	},
	containerSidePanel: {
		display: 'flex',
		flexDirection: 'row',
		gap: 10,
		justifyContent: 'space-evenly'
	},
	containerPanelFooter: {
		display: 'flex',
		flexDirection: 'column',
		gap: 10
	},
	estimateBPImage: {
		width: 500,
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto'
	},
	underlinedText: {
		borderBottomWidth: 1,
		borderBottomColor: '#000'
	},
	assemblyBox: {
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid',
		margin: 0,
		marginTop: 20,
		marginBottom: 20,
		padding: 10
	},
	documentTitle: {
		fontSize: 20,
		marginBottom: 10,
		textAlign: 'center',
		color: 'black',
		fontWeight: 700,
		fontFamily: 'Inter',
		textTransform: 'uppercase'
	},

	quoteTotal: {
		borderBottomWidth: 1,
		borderBottomColor: '#000',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 20,
		paddingBottom: 5
	},

	quoteTotalLabel: {
		fontSize: 14,
		fontWeight: 700
	},

	quoteTotalValue: {
		fontSize: 14,
		fontWeight: 700
	},

	commentHeading: {
		fontSize: 14,
		fontWeight: 700,
		fontFamily: 'Inter',
		marginBottom: 5
	},

	horizontalRule: {
		borderBottomWidth: 1,
		borderBottomColor: '#000',
		marginBottom: 15
	},

	bold: {
		fontWeight: 700,
		fontFamily: 'Inter',
		fontSize: 10
	},

	bulletList: {
		marginTop: 5,
		marginLeft: 10
	},

	listItem: {
		flexDirection: 'row',
		marginBottom: 5
	},

	bulletPoint: {
		width: 10,
		fontSize: 10,
		fontFamily: 'Inter'
	},

	listItemText: {
		fontSize: 10,
		fontFamily: 'Inter',
		flex: 1
	},

	unorderedList: {
		marginTop: 5,
		marginBottom: 10,
		marginLeft: 10
	},

	infoRow: {
		flexDirection: 'row',
		marginBottom: 5
	},

	discountNotice: {
		fontSize: 8,
		fontStyle: 'italic',
		color: '#555'
	},

	terms: {
		margin: 10,
		padding: 15,
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid',
		marginTop: 20
	},

	totalContainer: {
		alignItems: 'flex-end',
		marginVertical: 1,
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid',
		height: '.5in',
		width: '2in',
		marginLeft: 'auto',
		flexDirection: 'row',
		justifyContent: 'space-between',
		padding: '10px 5px 0 5px'
	},

	totalLabel: {
		fontWeight: 700,
		fontSize: 10,
		marginRight: 20
	},

	totalValue: {
		fontSize: 10
	},
	comments: {
		margin: 10,
		padding: 15,
		borderWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid'
	},
	tableContainer: {
		marginBottom: 10,
		marginTop: 5
	},

	tableRowNoGap: {
		flexDirection: 'row',
		fontFamily: 'Inter',
		fontWeight: 400,
		textAlign: 'right',
		borderLeftWidth: 1,
		borderRightWidth: 1,
		borderBottomWidth: 1,
		borderColor: '#000',
		borderStyle: 'solid',
		minHeight: 25,
		paddingBottom: 5,
		breakInside: 'avoid'
	},

	summarySection: {
		marginTop: 0,
		marginBottom: 10
	}
});
